import { Box } from "@mui/material";
import { useEffect, useState } from "react";

export default function TermsAndConditions() {
  const [termsHtml, setTermsHtml] = useState("");

  useEffect(() => {
    fetch("/terms.html")
      .then((response) => response.text())
      .then((data) => {
        setTermsHtml(data);
      })
      .catch((error) => {
        console.error("Error fetching terms:", error);
      });
  }, []);

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Box
        sx={{
          width: "100%",
          maxWidth: 960,
          color: "white",
          backgroundColor: "rgba(19,19,19,.9)",
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
          px: { xs: 2.5, sm: 4 },
          py: { xs: 3, sm: 4 },
          borderRadius: "20px",
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
      </Box>
    </Box>
  );
}
